import React from 'react';
import { useCopywriter, useCopywriterDispatch } from './CopywriterContext';

export default () => {
  const { error } = useCopywriter();
  const dispatch = useCopywriterDispatch();

  return error && (
    <>
      <p className="s-copywriter-editor__text s-copywriter-editor__text_gray s-copywriter-editor__text_semi-bold">
        {i18n.t('assistant.error.title')}
      </p>
      <p className='s-copywriter-editor__text s-copywriter-editor__text_gray'>
        {i18n.t(`assistant.error.${error}`)}
      </p>
      { error === 'pro_tariff_needed' ? (
        <a className="btn btn-form" href="/design/packages">{i18n.t('assistant.error.upgrade')}</a>
      ) : (
        <button className="btn btn-form" onClick={() => dispatch({ type: 'error', error: null })}>{i18n.t('assistant.error.clear')}</button>
      )}
    </>
  );
};
